(function(angular){
	'use strict';
	
	angular.module('imageLazyModule', [
		'BaseConfig',
		'revealModule'
	]);

})(window.angular);